
import Vue from 'vue';
import { Modal, Button } from '@descomplica/vue-components';
import i18n from '@/i18n';

interface Data {
  isActive: Boolean;
}

export default Vue.extend({
  components: {
    Modal,
    Button,
  },
  props: {
    title: {
      type: String,
      default: i18n.t('sayHelloNotes'),
    },
    subtitle: {
      type: String,
      default: i18n.t('nowYouCanTakeNotesWithinYourClasses'),
    },
    buttonConfirmationTxt: {
      type: String,
      default: i18n.t('comeOn'),
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      isActive: this.active,
    };
  },
  watch: {
    active(active) {
      this.isActive = active;
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    confirmationClick() {
      this.closeModal();
      this.isActive = false;
    },
    updateActive(active: boolean) {
      if (!active) {
        this.closeModal();
      }
      this.$emit('update:active', active);
    },
  },
});
